export const selectedStrategySelect = (state) =>
  state.portfolio.selectedStrategy;

export const selectedPortfolioSelect = (state) =>
  state.portfolio.selectedPortfolio;

export const portfolioFetchingSelect = (state) =>
  state.portfolio.isPortfolioFetching;

export const portfolioReFetchingSelect = (state) =>
  state.portfolio.isPortfolioReFetching;

export const totalPortfolioSelect = (state) => state.portfolio.totalPortfolio;

export const totalPortfolioPagesSelect = (state) =>
  state.portfolio.totalPortfolioPages;

export const activeStrategyListSelect = (state) =>
  state.portfolio.activeStrategies;

export const portfolioSearchValueSelect = (state) =>
  state.portfolio.portfolioSearchValue;

export const showAddFundsModalSelect = (state) =>
  state.portfolio.showAddFundsModal;

export const showStatusModalSelect = (state) => state.portfolio.showStatusModal;
